import paper from "paper";
import { PaperOffset } from "paperjs-offset";
import { go, each, filter, reduce } from "fxjs/es";
import { paper_stroke_styles } from "../../constants/svg_examples.js";
import { calculatePathOffset } from "../path_offset_algorithm/path_offset.js";

export const getPaperPathFromSVGpathData = ({
  path_data,
  paper_scope = paper,
  name,
  closed = true,
}) => {
  name && paper_scope.project.activeLayer.getItem({ name })?.remove();
  const paper_path = new paper_scope.Path(path_data);
  paper_path.set(Object.assign({ name, closed }, paper_stroke_styles.main));
  sanitizePaperPath(paper_path);
  paper_scope.project.activeLayer.addChild(paper_path);
  return paper_path;
};

const sanitizePaperPath = (paper_path) => {
  !paper_path.clockwise && paper_path.reverse();
  paper_path.closed = true;
  return paper_path;
};

const cloneArtboardRectToCanvas = (art_board_size, canvas_el) => {
  canvas_el.width = art_board_size.width;
  canvas_el.height = art_board_size.height;
  Object.assign(canvas_el.style, {
    position: "fixed",
    left: `${art_board_size.x || 0}px`,
    top: `${art_board_size.y || 0}px`,
  });
};

export const getPaperScope = ({
  art_board_size,
  canvas_el = document.createElement("canvas"),
  is_retina_dpi = false,
  is_append_to_DOM,
  automatic_insert = false,
}) => {
  const paper_scope = new paper.PaperScope();
  canvas_el.setAttribute("hidpi", is_retina_dpi ? "on" : "off");
  cloneArtboardRectToCanvas(art_board_size, canvas_el);
  paper_scope.setup(canvas_el);
  paper_scope.settings.insertItems = automatic_insert;
  // paper_scope.view.translate(art_board_size.margin);
  is_append_to_DOM && document.body.appendChild(canvas_el);
  Object.assign(canvas_el.style, {
    zIndex: `${Number.MIN_SAFE_INTEGER}`,
    display: "none",
  });
  // const tool = new paper_scope.Tool();
  // tool.onMouseDown = (e) => {
  //   const hit_res = paper_scope.project.activeLayer.hitTest(e.point, {
  //     tolerance: 10,
  //     handles: true,
  //     segments: true,
  //   });
  //   console.log("hit", e, hit_res);
  // };
  return paper_scope;
};

export const pathOffsetting = ({ paper_path, name, offset_size }) => {
  go(
    paper_path.layer.getItems({ name }),
    each((path) => path.remove())
  );
  let offset_path = PaperOffset.offset(paper_path, offset_size, {
    join: "round",
    insert: false,
  });
  go(
    offset_path.curves,
    filter((c) => c.length < 5),
    each((c) => c.remove())
  );
  offset_path.set(paper_stroke_styles.offset_path);
  offset_path.name = name;
  paper_path.layer.addChild(offset_path);
  return offset_path;
};

export const pathOffsetting_adv = ({ paper_path, name, offset_size }) => {
  go(
    paper_path.layer.getItems({ name }),
    each((path) => path.remove())
  );
  let offset_path = calculatePathOffset(paper_path, offset_size, "round");
  offset_path.set(paper_stroke_styles.offset_path);
  offset_path.name = name;
  paper_path.layer.addChild(offset_path);
  return offset_path;
};

export const createCircle = ({
  paper_scope,
  radius,
  init_position = { x: 0, y: 0 },
  name,
  option,
  insert = false,
}) => {
  const paper_circle = new paper_scope.Path.Circle(
    new paper_scope.Point(init_position.x, init_position.y),
    radius
  );
  if (insert) {
    paper_scope.project.activeLayer.addChild(paper_circle);
    paper_circle.set(option || paper_stroke_styles.tangent_circle);
  }
  paper_circle.name = name;
  return paper_circle;
};

export const markCircle = ({ paper_scope, point, name }) => {
  const circle = new paper_scope.Path.Circle({
    center: point,
    radius: 3,
  });
  circle.set({
    fillColor: "lime",
    name,
  });
  paper_scope.project.activeLayer.addChild(circle);
};

export const markSingleStar = ({ paper_scope, paper_point }) => {
  const star_item = paper_scope.project.activeLayer.getItem({ name: "star" });
  if (!star_item) {
    const paper_star = new paper_scope.Path.Star({
      center: paper_point,
      points: 6,
      radius1: 4,
      radius2: 6,
      fillColor: "orange",
    });
    paper_star.name = "star";
    paper_scope.project.activeLayer.addChild(paper_star);
  } else {
    star_item.position = paper_point;
  }
};

export const getMinimumPoint = ({ intersections_arr, target_coord }) => {
  return reduce((min_location, curve_location) => {
    if (
      min_location.point[target_coord] > curve_location.point[[target_coord]]
    ) {
      min_location = curve_location;
    }
    return min_location;
  }, intersections_arr);
};
